import dateFormat, { i18n } from 'dateformat';

i18n.dayNames = [
  "Dim",
  "Lun",
  "Mar",
  "Mer",
  "Jeu",
  "Ven",
  "Sam",
  "Dimanche",
  "Lundi",
  "Mardi",
  "Mercredi",
  "Jeudi",
  "Vendredi",
  "Samedi",
];

i18n.monthNames = [
  "jan",
  "févr",
  "mars",
  "avr",
  "mai",
  "juin",
  "jul",
  "août",
  "sep",
  "oct",
  "nov",
  "dec",
  "Janvier",
  "Février ",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Decembre",
];

i18n.timeNames = ["a", "p", "am", "pm", "A", "P", "AM", "PM"];

export default dateFormat;
